module.exports = __webpack_public_path__ + "sgby/img/guanyu-pic.8270d33.png";